






































































































































































































import Api from "@/api/Api";
import Vue from "vue";
import { UserLogin } from "../../../interfaces/userlogin";
import { Sale } from "../../../interfaces/sale";
import Encoding from "encoding-japanese";
export default Vue.extend({
  computed: {
    yms(): Record<string, string> {
      const ret: { [key: string]: string } = {};
      for (
        const start = new Date(this.startMonth.getTime()),
          date = new Date(this.endMonth.getTime());
        start <= date;
        date.setMonth(date.getMonth() - 1)
      ) {
        ret[
          date.getFullYear() + "-" + ("00" + (date.getMonth() + 1)).slice(-2)
        ] =
          date.getFullYear() +
          "年" +
          ("00" + (date.getMonth() + 1)).slice(-2) +
          "月";
      }

      return ret;
    },
    startMonth(): Date {
      return new Date(2020, 8, 1);
    },
    endMonth(): Date {
      const d = new Date();
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(0);
      d.setMilliseconds(0);
      d.setDate(1);
      d.setFullYear(d.getFullYear() + 1);

      return d;
    },
    theMonth(): string {
      const queryMonth = "" + (this.$route.query.month || "");
      return queryMonth.match(/^\d\d\d\d-\d\d$/)
        ? queryMonth
        : this.$formatter.dateHyphened(new Date()).substr(0, 7);
    },
    theMonthDate(): Date {
      const [year, month] = this.theMonth.split("-");
      const r = new Date(parseInt(year, 10), parseInt(month, 10) - 1, 1);
      return r;
    },
    prevMonth(): string | null {
      const d = new Date(this.theMonthDate.getTime());
      d.setMonth(this.theMonthDate.getMonth() - 1);
      if (d < this.startMonth) {
        return null;
      }

      return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2);
    },
    nextMonth(): string | null {
      const d = new Date(this.theMonthDate.getTime());
      d.setMonth(this.theMonthDate.getMonth() + 1);
      if (this.endMonth < d) {
        return null;
      }

      return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2);
    },
    totalNet() {
      let total = 0;
      for (const sale of this.sales) {
        total += +sale.net;
      }

      return total;
    },
    totalTax() {
      let total = 0;
      for (const sale of this.sales) {
        total += +sale.tax;
      }

      return total;
    },
    outputDate() {
      return new Date();
    }
  },
  data(): {
    isLoading: boolean;
    sales: Sale[];
    userLogins: { [key: string]: UserLogin };
    currentYm: string;
  } {
    return {
      isLoading: false,
      sales: [],
      userLogins: {},
      currentYm: ""
    };
  },
  created() {
    this.loadSales();
  },
  watch: {
    $route() {
      this.loadSales();
    }
  },
  methods: {
    async downloadAsCsv() {
      const api = Api.singleton();
      const rows = [] as unknown[][];
      rows.push([
        "出力日",
        this.$formatter.date(this.outputDate),
        "税込合計",
        "" + (this.totalNet + this.totalTax),
        "税抜合計",
        "" + this.totalNet,
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      ]);
      rows.push([
        "No.",
        "申込ID",
        "クライアント名",
        "エリア",
        "会社名・店舗名",
        "支払金額",
        "契約期間",
        "経過期間",
        "申込日",
        "支払方法",
        "支払日",
        "掲載開始日",
        "掲載終了日"
      ]);

      for (const sale of this.sales) {
        const row = [];
        const publishmentOrder = await this.$store.dispatch(
          "loadResource",
          sale.publishmentOrder
        );
        const advertisement = await this.$store.dispatch(
          "loadResource",
          publishmentOrder.advertisement
        );
        row.push(sale.id);
        row.push(publishmentOrder.advertisement.formattedAdvertisementId);
        row.push(advertisement.owner.companyName);
        row.push(
          publishmentOrder.region.name + " " + publishmentOrder.locality.name
        );
        row.push(advertisement.storeName);
        row.push(+sale.net + +sale.tax);
        row.push(publishmentOrder.course.periodLabel);
        row.push(sale.saleIndexLabel);
        row.push(this.$formatter.date(publishmentOrder.orderedAt));
        if (publishmentOrder.paymentStatus == "none") {
          row.push("未入金");
        } else {
          row.push(
            publishmentOrder.paymentMethodLabel +
              "(" +
              publishmentOrder.paymentStatusLabel +
              ")"
          );
        }
        row.push(this.$formatter.date(publishmentOrder.paidAt));
        row.push(this.$formatter.date(publishmentOrder.publishesAt));
        row.push(this.$formatter.date(publishmentOrder.unpublishesAt));
        rows.push(row);
      }
      const csv = rows
        .map(row => {
          return row
            .map((cell: unknown) => {
              return '"' + ("" + cell).replace('"', '""') + '"';
            })
            .join(",");
        })
        .join("\n");
      const sjisCsv = Encoding.convert(
        csv.split("").map((c: string) => {
          return c.charCodeAt(0);
        }),
        "SJIS",
        "UNICODE"
      );
      api.downloadAs(
        new Blob([new Uint8Array(sjisCsv)]),
        "sales-" + this.theMonth + ".csv"
      );
    },
    gotoMonth(month: string) {
      this.$router.push({
        name: "AdministratorSalesIndex",
        query: {
          month
        }
      });
    },
    async loadSales() {
      this.isLoading = true;
      this.$set(this, "sales", []);
      const api = Api.singleton();
      const theMonth = this.theMonth;
      const res = (
        await api.call({
          method: "GET",
          resource: "/api/adv/sales",
          query: {
            ["month_recordedAt"]: theMonth
          }
        })
      )["hydra:member"] as Sale[];

      if (this.theMonth === theMonth) {
        this.$set(this, "sales", res);
      }
      this.isLoading = false;
    }
  }
});
